import React from "react";
import ActionLink from "./ActionLink";

const ActionGroup = ({ actions, className = "" }) => {
  return (
    <div className={`button-row ${className}`.trim()}>
      {actions.map((action) => (
        <ActionLink key={action.label} {...action} />
      ))}
    </div>
  );
};

export default ActionGroup;
